import { NotificationService } from 'src/app/services/notification.service';
import { AppStateProvider } from './../../services/app-state.provider';
import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  lastRefreshedTime: any = '';
  notificationState: boolean = false;
  notificationCount: number = 0;
  parkDetails;
  selectedPark = localStorage.getItem('parkId');
  displayPark = '';
  subscriptions: Subscription;
  tokens: any;

  constructor(
    private appStateSrv: AppStateProvider,
    private notificationSrv: NotificationService,
    private commonService: CommonService,
    private router: Router
  ) {
    // console.log("const",localStorage.getItem('parkId'))
    if (
      (localStorage.getItem('parkId') == '' ||
        localStorage.getItem('parkId') == null) &&
      localStorage.getItem('claAdminId')
    ) {
      // console.log("run func")
      // this.getParkbyClaId(); //closed for token
    }
    // this.commonService.getParkByCLAId()
    this.selectedPark = localStorage.getItem('parkId');

    // if(this.parkDetails.length > 0) {
    //   this.parkDetails.forEach(element => {
    //     if(this.selectedPark === element.parkId) {
    //       this.displayPark = element.parkName+', '+element.cityName
    //       console.log(this.displayPark)
    //     }
    //   });
    // }
    this.appStateSrv.getNotificationDrawerState().subscribe((status) => {
      this.notificationState = status;
    });
    this.notificationSrv.getSavedNotifications().subscribe((notifications) => {
      if (notifications !== null) this.getNotificationCount(notifications);
    });

    // this.appStateSrv.toggleNotificationsDrawer(this.notificationState)
  }

  getNotificationCount(notifications) {
    this.notificationCount = 0;
    notifications.forEach((notify) => {
      if (notify.isNew) this.notificationCount++;
    });
  }
  ngOnChanges() {
    // console.log(this.parkDetails);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    // this.reloadCurrentRoute()

    this.subscriptions = this.commonService.parkDropDownDetailsArray.subscribe(
      (res) => {
        // console.log(res)
        this.parkDetails = res;
        this.parkDetails =
          this.parkDetails.length > 0
            ? this.parkDetails
            : JSON.parse(localStorage.getItem('parkDropDownDetails'));

        // console.log(this.parkDetails);
        // console.log(JSON.parse(localStorage.getItem('parkDropDownDetails')));

        this.selectedPark = localStorage.getItem('parkId');
        if (this.parkDetails != null && this.selectedPark == null) {
          this.displayPark =
            this.parkDetails[0].parkName + ', ' + this.parkDetails[0].cityName;
          // console.log(this.displayPark)
        } else if (this.parkDetails != null && this.selectedPark) {
          this.parkDetails.forEach((element) => {
            if (element.parkId === this.selectedPark) {
              // console.log(this.selectedPark);
              this.displayPark = element.parkName + ', ' + element.cityName;
            }
          });
        } else {
          // this.commonService.getParkByCLAId(); //closed for token
        }
      }
    );
    // console.log(this.displayPark);
    this.lastRefreshedTime = this.appStateSrv.lastRefreshedTime();
  }

  toggleNotification() {
    this.notificationState = !this.notificationState;
    this.appStateSrv.toggleNotificationsDrawer(this.notificationState);
    if (localStorage.getItem('parkId')) {
      this.notificationSrv.getAllNotifications().subscribe();
    }
  }

  setParkId(event, locationId) {
    console.log(event);
    this.parkDetails.forEach((element) => {
      if (event === element.parkId) {
        this.displayPark = element.parkName + ', ' + element.cityName;
      }
    });
    localStorage.setItem('parkId', event);
    console.log(locationId);
    if (locationId != '' || locationId != null || locationId != 'null') {
      localStorage.setItem('locationId', locationId);
    } else {
      localStorage.setItem('locationId', '1');
    }
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');
    localStorage.removeItem('expandNavUser');
    const route = {
      index: '0',
      name: 'Overview',
      link: '/parkite-overview',
    };
    this.appStateSrv.setSideNavState(route);

    if (this.router.url.includes('parkite-overview')) {
      window.location.reload();
    }

    this.router.navigate(['/parkite-overview']);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    // console.log('Clicked outside:', e);
  }

  getParkbyClaId() {
    this.commonService.getParkByCLAId().subscribe((res) => {
      console.log(res.list[0].parkId);
      if (res.isValid) {
        // console.log('parkId', res.list[0].parkId)
        // localStorage.setItem('parkId', res.list[0].parkId);
        localStorage.setItem('parkDropDownDetails', JSON.stringify(res.list));
      }
    });
  }

  //   reloadCurrentRoute() {
  //     if (!localStorage.getItem('foo')) {
  //       localStorage.setItem('foo', 'no reload')
  //       window.location.reload()
  //     }
  // }
}
